var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManatSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368 272V440C368 462.094 350.094 480 328 480S288 462.094 288 440V272C288 245.875 277.688 221.469 258.969 203.219C248.863 193.375 236.891 186.207 224 181.621V448C224 465.688 209.672 480 192 480S160 465.688 160 448V181.869C122.555 194.986 96 229.984 96 272V440C96 462.094 78.094 480 56 480S16 462.094 16 440V272C16 185.285 77.461 114.467 160 99.465V64C160 46.312 174.328 32 192 32S224 46.312 224 64V99.068C257.955 105.293 289.404 121.199 314.781 145.906C349.109 179.344 368 224.094 368 272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManatSign);
export default __webpack_public_path__ + "static/media/manat-sign.37f20e8ae97a7ddc8e8a9633431758cd.svg";
export { ForwardRef as ReactComponent };